(function () {
  const BACKEND = 'https://invernadas-copy-production.up.railway.app';
  const DEFAULT_LOCATION = '942178329'; // Salvador
  const SOLD_OUT_TEXT = 'Agotado';

  let lastLocationId = null;
  let checkTimer = null;

  async function getLocationId() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      return (cart.attributes && cart.attributes['_cds_locationId']) || DEFAULT_LOCATION;
    } catch (e) {
      return DEFAULT_LOCATION;
    }
  }

  function getVisibleCards() {
    return [...document.querySelectorAll('.product-card-wrapper[data-cds-product-id]')];
  }

  function getButtonForCard(card) {
    // Botón de quick-add (single variant form submit o modal opener)
    return card.querySelector('.quick-add__submit');
  }

  function getButtonSpan(btn) {
    // El primer <span> visible es el texto principal
    return btn.querySelector('span:not(.sold-out-message):not(.loading__spinner):not(.icon-wrap)');
  }

  function markSoldOut(card) {
    const btn = getButtonForCard(card);
    if (!btn) return;
    btn.disabled = true;
    btn.setAttribute('data-cds-sold-out', 'true');
    const span = getButtonSpan(btn);
    if (span) {
      btn.setAttribute('data-cds-original-text', span.textContent.trim());
      span.textContent = SOLD_OUT_TEXT;
    }
    // También deshabilitar el hidden input del form si existe
    const input = card.querySelector('input[name="id"].product-variant-id');
    if (input) input.disabled = true;
  }

  function markAvailable(card) {
    const btn = getButtonForCard(card);
    if (!btn) return;
    if (btn.getAttribute('data-cds-sold-out') !== 'true') return;
    btn.disabled = false;
    btn.removeAttribute('data-cds-sold-out');
    const span = getButtonSpan(btn);
    if (span) {
      const original = btn.getAttribute('data-cds-original-text');
      if (original) span.textContent = original;
      btn.removeAttribute('data-cds-original-text');
    }
    const input = card.querySelector('input[name="id"].product-variant-id');
    if (input) input.disabled = false;
  }

  async function checkCollectionStock(locationId) {
    const cards = getVisibleCards();
    if (!cards.length) return;

    const productIds = [...new Set(cards.map(c => c.dataset.cdsProductId).filter(Boolean))];
    if (!productIds.length) return;

    try {
      const data = await fetch(
        BACKEND + '/stock/levels/bulk?locationId=' + locationId + '&productIds=' + productIds.join(',')
      ).then(r => r.json());

      const stockMap = {};
      (data.products || []).forEach(p => { stockMap[String(p.productId)] = p.available; });

      cards.forEach(card => {
        const pid = String(card.dataset.cdsProductId);
        const stock = stockMap[pid] !== undefined ? stockMap[pid] : null;

        if (stock === null) return; // Sin datos, no tocar

        if (stock === 0) {
          markSoldOut(card);
        } else {
          markAvailable(card);
        }
      });
    } catch (e) {
      console.error('[CDS] Error stock colección:', e);
    }
  }

  async function run() {
    const locationId = await getLocationId();
    lastLocationId = locationId;
    checkCollectionStock(locationId);
  }

  // Polling liviano: detectar cambio de ubicación (cada 3s mientras está en colecciones)
  function pollLocationChange() {
    clearTimeout(checkTimer);
    checkTimer = setTimeout(async () => {
      const locationId = await getLocationId();
      if (locationId !== lastLocationId) {
        lastLocationId = locationId;
        checkCollectionStock(locationId);
      }
      pollLocationChange();
    }, 3000);
  }

  // Solo correr en páginas de colección y búsqueda
  const isCollection = document.querySelector('.collection') !== null
    || window.location.pathname.startsWith('/collections/')
    || window.location.pathname.startsWith('/search');

  if (!isCollection) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { run(); pollLocationChange(); });
  } else {
    run();
    pollLocationChange();
  }
})();
